const SET_ITEM = (state, data) => state.item = data

const SET_LOADING = (state) => state.status = 1

const SET_SUCCESS = (state) => state.status = 2

const SET_ERROR = (state) => state.status = 3

const RESET_STATUS = (state) => state.status = 0

const SET_ITEM_TEXT = (state, data) => state.item.text = data

const SET_REMOVABLE = (state, id) => state.removables.push(id)

const RESET_REMOVABLES = (state) => state.removables = []

export default {
  SET_ITEM,
  SET_ERROR,
  SET_SUCCESS,
  SET_LOADING,
  RESET_STATUS,
  SET_ITEM_TEXT,
  SET_REMOVABLE,
  RESET_REMOVABLES
}
